import gql from "graphql-tag"
import MediaRevisionFragment from "../fragment/MediaRevisionFragment"

export default gql`
  ${MediaRevisionFragment}
  mutation mediaUpgradeRetry($revisionId: String!) {
    revision: mediaUpgradeRetry(revisionId: $revisionId) {
      ...MediaRevisionFragment
    }
  }
`
